import { format } from "date-fns";

export const SUPPORT_SESSIONS_MAX_PER_MONTH = 2;

export const SUPPORT_SESSIONS_RTD_KEY = "supportSessions";

export const getSupportSessionsPath = ({ agencyID }) =>
  `agencies/${agencyID}/${SUPPORT_SESSIONS_RTD_KEY}`;

export const getSupportSessionsYearMonth = (date = new Date()) =>
  format(date, "yyyy-MM");

export const canScheduleSupportSession = ({ supportSessions }) => {
  if (!supportSessions) {
    return true;
  }

  const currentYearMonth = getSupportSessionsYearMonth();

  if (supportSessions.yearMonth !== currentYearMonth) {
    return true;
  }

  const sessionsCount = Number(supportSessions.sessionsCount) || 0;

  return sessionsCount < SUPPORT_SESSIONS_MAX_PER_MONTH;
};

export const buildNextSupportSessionsNode = ({ supportSessions }) => {
  const currentYearMonth = getSupportSessionsYearMonth();
  const lastScheduledAt = Date.now();

  if (!supportSessions || supportSessions.yearMonth !== currentYearMonth) {
    return {
      yearMonth: currentYearMonth,
      sessionsCount: 1,
      lastScheduledAt,
    };
  }

  const currentCount = Number(supportSessions.sessionsCount) || 0;

  if (currentCount >= SUPPORT_SESSIONS_MAX_PER_MONTH) {
    return null;
  }

  return {
    yearMonth: currentYearMonth,
    sessionsCount: currentCount + 1,
    lastScheduledAt,
  };
};
